<template>
  <!-- fa fa-heart red -->
  <div :id="id" class="bubble-box">
    <img :src="src" :class="type" />
  </div>
</template>

<script>
export default {
  name: 'LoveComponent',
  props: ['type', 'src', 'room_id', 'id']
}
</script>
